import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { AdminSetariComponent } from './admin-setari.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfigurariComponent } from './configurari/configurari.component';
import { TypeImagineComponent } from './type-imagine/type-imagine.component';
import { AddTypeImageComponent } from './type-imagine/add-type-image/add-type-image.component';
import { EditTypeImageComponent } from './type-imagine/edit-type-image/edit-type-image.component';
import { AddConfigComponent } from './configurari/add-config/add-config.component';
import { EditConfigComponent } from './configurari/edit-config/edit-config.component';
import { CronsComponent } from './crons/crons.component';
import { AddCronsComponent } from './crons/add-crons/add-crons.component';
import { EditCronsComponent } from './crons/edit-crons/edit-crons.component';



@NgModule({
    declarations: [
        AdminSetariComponent,
        ConfigurariComponent,
        TypeImagineComponent,
        AddTypeImageComponent,
        EditTypeImageComponent,
        AddConfigComponent,
        EditConfigComponent,
        CronsComponent,
        AddCronsComponent,
        EditCronsComponent,
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [AdminSetariComponent]
})
export class AdminSetariModule { }
